import { useContext } from 'react';
import { ConsentContext } from '../components/lib/Sourcepoint';

export const useConsent = () => {
  const { consent } = useContext(ConsentContext);
  const isConsentReady = !!consent?.tcString;
  return { isConsentReady, consent };
};
